import { ActivityGroupResponse } from '../../api/core/models/api/activity-group-response';
import { ClientAction } from '../../model/client-model/client-action';
import { ClientBoard } from '../../model/client-model/client-board';
import { ClientIndicator } from '../../model/client-model/client-indicator';
import { ClientNode } from '../../model/client-model/client-node';
import { Tree } from '../../services/backend/model/tree';
import { InventoriesWithValues, InventoryWithValues } from '../../store/inventories/inventories.types';

export interface RawBoardData {
  board: ClientBoard;
  clientNodes: ClientNode[];
  clientIndicators: ClientIndicator[];
  clientActions: ClientAction[];
  clientInventories: InventoriesWithValues;
  tree?: Tree;
  activityGroups: ActivityGroupResponse[];
}

export function getBaselineInventoryValues(
  inventories: InventoriesWithValues,
  board: ClientBoard
): InventoryWithValues | undefined {
  for (const inv of inventories.values()) {
    if (inv.inventoryYear === board.boardSettings.timeline.scenarioStartYear) {
      return inv;
    }
  }
  return undefined;
}
